<template>
  <model-form
    ref="modelForm"
    :model="tipShare"
    modal-type="modal"
    read-only
  >
    <div class="row q-col-gutter-x-sm items-center">
      <router-field
        :field-value="tipShare.tipShareRule?.name || 'No Tip Share Rule'"
        class="col-6"
        label="Tip Share Rule"
        :link="{
          name: 'admin:settings-category-name-id',
          params: {
            category: 'site',
            name: 'tip-share-rules',
            id: tipShare.tipShareRule?.id
          }
        }"
        :disable="$_.isNil(tipShare.tipShareRule)"
      />
      <router-field
        :field-value="employeeValue"
        class="col-6 sensitive-data"
        label="Employee"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'customers',
            name: 'users',
            id: tipShare.orderItem?.paidUser?.id
          }
        }"
        :disable="$_.isNil(tipShare.orderItem?.paidUser)"
      />
      <model-form-input
        field="paymentType"
        class="col-6"
        label="Payment Type"
        :decode="paymentType => $_.startCase(paymentType)"
        readonly
      />
      <router-field
        :field-value="orderValue"
        class="col-6"
        label="Order"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'customers',
            name: 'orders',
            id: tipShare.orderItem?.order?.id
          }
        }"
        :disable="$_.isNil(tipShare.orderItem?.order)"
      />
      <model-form-input
        field="tipOutAmount"
        class="col-6"
        label="Tip Out Amount"
        :prefix="currentCircuit.localeCurrencySymbol"
        readonly
      />
      <model-form-input
        field="tipIncomeAmount"
        class="col-6"
        label="Tip Income Amount"
        :prefix="currentCircuit.localeCurrencySymbol"
        readonly
      />
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RouterField from 'src/modules/admin/components/RouterField'

export default {
  name: 'TipShareForm',
  components: {
    ModelForm,
    RouterField
  },
  configuration: ['currentCircuit'],
  models: {
    tipShare: {
      tipShareRule: {
        fields: ['id', 'name']
      },
      orderItem: {
        fields: ['id', 'amount', 'price', 'taxAmount', 'state'],
        paidUser: {
          fields: ['id', 'firstName', 'lastName']
        },
        order: {
          fields: ['id']
        }
      },
      tipPoolTips: {
        fields: ['id', 'amount', 'state'],
        tipPool: {
          fields: ['id']
        },
        tipPoolType: {
          fields: ['id', 'name']
        }
      }
    }
  },
  data () {
    return {
      tab: 'details'
    }
  },
  computed: {
    employeeValue () {
      if (!_.isNil(this.tipShare.orderItem?.paidUser)) {
        return this.tipShare.orderItem?.paidUser?.name
      } else {
        return 'Unassigned'
      }
    },
    orderValue () {
      if (!_.isNil(this.tipShare.orderItem?.order)) {
        return `O${this.tipShare.orderItem?.order?.id}`
      } else {
        return 'No Order'
      }
    }
  }
}
</script>
